import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  InputText,
  SidePanel,
  SidePanelLoader,
  SidePanelType,
  ButtonPrimary,
  ButtonPseudo,
} from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetGeographialRiskQuery,
  useUpdateGeographicalRiskScoreMutation,
} from './store/services';

import ROUTES from '../../routes';

import cn from './geographical.module.css';

const GeographicalRiskForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [riskScoreValue, setRiskScoreValue] = useState('');

  const { country } = useAppSelector((state) => state.geographical);

  const navigate = useNavigate();
  const { id } = useParams();

  const [getCountry, { isLoading, isFetching }] =
    useLazyGetGeographialRiskQuery();
  const [updateCountryRiskScore, { isLoading: requestInProgress }] =
    useUpdateGeographicalRiskScoreMutation();

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(ROUTES.GEOGRAPHICAL);
    }, 100);
  };

  const updateCountryRiskScoreAction = () => {
    updateCountryRiskScore({
      id: id as string,
      body: {
        riskScore: Number(riskScoreValue),
      },
    });
  };

  useEffect(() => {
    if (country) {
      setRiskScoreValue(country?.riskScore?.toString() || '');
    }
  }, [country]);

  useEffect(() => {
    if (id) {
      getCountry(id);
    }
  }, [id]);

  useEffect(() => {
    setPanelIsOpen(true);
  }, []);

  let content;

  if (isLoading || isFetching) {
    content = <SidePanelLoader />;
  } else {
    content = (
      <>
        <div className={cn.countryFormGroup}>
          <InputText
            name="name"
            title="Name"
            value={country?.name}
            placeholder=""
            disabled
          />
        </div>
        <div className={cn.countryFormGroup}>
          <InputText
            name="alpha3"
            title="Alpha 3"
            value={country?.alpha3}
            placeholder=""
            disabled
          />
        </div>
        <div className={cn.countryFormGroup}>
          <InputText
            name="riskScore"
            title="Risk Score"
            value={riskScoreValue}
            placeholder=""
            onChange={(e) => setRiskScoreValue(e.target.value)}
          />
        </div>
      </>
    );
  }

  return (
    <SidePanel
      title="Country details"
      isOpen={panelIsOpen}
      type={SidePanelType.AML}
      onClose={handleClose}
      sidepanelExpandedKey="country-details"
      footer={
        <>
          <ButtonPrimary
            text={requestInProgress ? 'Loading...' : 'Save'}
            onClick={updateCountryRiskScoreAction}
            disabled={
              requestInProgress ||
              isLoading ||
              isFetching ||
              Number(country?.riskScore) === Number(riskScoreValue)
            }
            bold
          />
          <ButtonPseudo text="Close" onClick={handleClose} bold />
        </>
      }
      closeOnClickOutside
    >
      {content}
    </SidePanel>
  );
};

export default GeographicalRiskForm;
